export default {
  STATUS: {
    QUALIFIER: "QL",
    TOURNAMENT: "TR",
    BOTH: "QT",
    REMOVED: "RE"
  }
};
